import TimelogsDashboardItem from './TimelogsDashboardItem';

export default TimelogsDashboardItem;
